import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  rootContainer: {
    width: '100%',
  },
  subHeading: {
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.15px',
    marginBottom: theme.spacing(3),
  },
  optionalText: {
    paddingTop: theme.spacing(0.25),
  },
  checkBoxRootContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(0.5),
  },
  checkBoxContainer: {
    height: theme.spacing(3),
    '& .MuiFormControlLabel-root': {
      marginRight: '0px !important',
    },
    '& p': {
      paddingTop: theme.spacing(0.25),
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '20px',
      letterSpacing: '0.25px',
      color: theme.palette.labraText.tertiary,
      fontFamily: theme.typography.fontFamily,
    },
  },
  sectionContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(3),
    width: '100%',
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
    width: '100%',
  },
  sectionHeadingContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  sectionHeading: {
    fontFamily: theme.typography.fontFamily,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.15px',
  },
  sectionText: {
    fontSize: '14px !important',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '20px !important',
    letterSpacing: '0.25px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    textAlign: 'left',
  },
  uploadImageWidth: {
    width: '100%',
  },
  marginBottom: {
    marginBottom: theme.spacing(5),
  },
  note: {
    marginTop: theme.spacing(3),
  },
}))
